import {createLoaderWorker} from '@loaders.gl/loader-utils';
import {NullLoader} from '../null-loader';

createLoaderWorker(NullLoader);
